<ng-container *ngIf="value || type === 'YES_NO' ||  value===0; else: other">
  <ng-container *ngIf="type === 'TEXT' || type === 'LONGTEXT'; else: nonText">
    <ng-container *ngTemplateOutlet="other"></ng-container>
  </ng-container>
  <ng-template #nonText>
    <div *ngIf="type === 'CURRENCY'; else: nonCurrency" [ngClass]="getCssClass()"
      pTooltip="{{ this.formatNumber() }} &euro; " tooltipPosition="bottom"> {{ this.formatNumber() }} &euro; </div>
  </ng-template>
  <ng-template #nonCurrency>
    <div *ngIf="type === 'DATE' || type === 'DATETIME'; else: nonDate" [ngClass]="getCssClass()" pTooltip="{{ value | date: (type
      === 'DATE' ? DATEPIPE_DATE_FORMAT : DATEPIPE_DATETIME_FORMAT) }}" tooltipPosition="bottom"> {{ value | date:
      (type === 'DATE' ? DATEPIPE_DATE_FORMAT : DATEPIPE_DATETIME_FORMAT) }} </div>
  </ng-template>
  <ng-template #nonDate>
    <div *ngIf="type === 'INTEGER'; else: nonInt" [ngClass]="getCssClass()" pTooltip="{{ this.formatNumber() }}"
      tooltipPosition="bottom">{{ this.formatNumber() }} </div>
  </ng-template>
  <ng-template #nonInt>
    <div *ngIf="type === 'DECIMAL'; else: nonDecimal" [ngClass]="getCssClass()" pTooltip="{{ this.formatNumber() }}"
      tooltipPosition="bottom">{{ this.formatNumber()}} </div>
  </ng-template>
  <ng-template #nonDecimal>
    <div *ngIf="type === 'PERCENTAGE'; else: nonNumber" [ngClass]="getCssClass()" pTooltip="{{ this.formatNumber() }}"
      tooltipPosition="bottom">{{ this.formatNumber() }} %</div>
  </ng-template>
  <ng-template #nonNumber>
    <div *ngIf="type === 'YES_NO'; else: nonYESNO" [ngClass]="getCssClass()">{{ value===undefined?'':(value?'Sí':'No')}}
    </div>
  </ng-template>
  <ng-template #nonYESNO>
    <p-overlayPanel #desTooltip1 appendTo="body" [showTransitionOptions]="'1000ms'" [hideTransitionOptions]="'500ms'">
      <span> {{ value || '&nbsp;' }} </span>
    </p-overlayPanel>
    <div *ngIf="type === 'HTML'; else: other" [ngClass]="getCssClass()" (mouseenter)="desTooltip1.toggle($event)"
      (mouseleave)="desTooltip1.toggle($event)"> <span [innerHTML]="value">{{ value || '&nbsp;' }}</span>
    </div>
  </ng-template>
</ng-container>
<ng-template #other>
  <div [ngClass]="getCssClass()" pTooltip="{{
    objectToString(value) }}" tooltipPosition="bottom" pTooltip="{{ objectToString(value) }}">{{ objectToString(value)
    }} </div>
</ng-template>